module.exports = __webpack_public_path__ + "img/bloodpoints.f04ac422.png";